import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=7fabfa3e&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fabfa3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fabfa3e')) {
      api.createRecord('7fabfa3e', component.options)
    } else {
      api.reload('7fabfa3e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=7fabfa3e&scoped=true&", function () {
      api.rerender('7fabfa3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29NY7lCxeBbT6/JS/comp/Accordion.vue"
export default component.exports